var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.currentLang
    ? _c(
        "a-dropdown",
        [
          _c(
            "span",
            { staticClass: "right-content__action" },
            [
              _c("icon-font", {
                staticStyle: { "font-size": "20px" },
                attrs: { type: _vm.languageCodes[_vm.currentLang].icon }
              })
            ],
            1
          ),
          _c(
            "a-menu",
            {
              attrs: { slot: "overlay", selectedKeys: [_vm.currentLang] },
              on: { click: _vm.changeLang },
              slot: "overlay"
            },
            _vm._l(_vm.locales, function(locale) {
              return _c("a-menu-item", { key: locale }, [
                _c(
                  "span",
                  {
                    attrs: {
                      role: "img",
                      "aria-label": _vm.languageCodes[locale].label
                    }
                  },
                  [_vm._v(_vm._s(_vm.languageIcons[locale]))]
                ),
                _vm._v(" " + _vm._s(_vm.languageCodes[locale].label) + " ")
              ])
            }),
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }